import PropTypes from 'prop-types';
import campaignsStrings from 'modules/campaigns/strings';

import { Wrapper, SearchBarWrapper, SearchBar, SearchBarIcon } from './CampaignsFilter.style';

const CampaignsFilter = ({ searchQuery, handleSearchBarInputChange }) => (
  <Wrapper>
    <SearchBarWrapper>
      <SearchBarIcon />
      <SearchBar
        placeholder={campaignsStrings.campaignsFilter.searchBarPlaceholder}
        value={searchQuery}
        onChange={handleSearchBarInputChange}
      />
    </SearchBarWrapper>
  </Wrapper>
);
CampaignsFilter.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
};

export default CampaignsFilter;
